import { render, staticRenderFns } from "./ViewStaticAssessment.vue?vue&type=template&id=45662872&"
import script from "./ViewStaticAssessment.vue?vue&type=script&lang=js&"
export * from "./ViewStaticAssessment.vue?vue&type=script&lang=js&"
import style0 from "./ViewStaticAssessment.vue?vue&type=style&index=0&id=45662872&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports